// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck.ck-label{\n  display:block\n}\n\n.ck.ck-voice-label{\n  display:none\n}\n\n.ck.ck-label{\n  font-weight:700\n}", ""]);
// Exports
module.exports = exports;
